import type { Option } from "@mdotm/shadcn/legacy/components";
import { FormField, Select, type SelectProps } from "@mdotm/shadcn/mdotm/components";
import { useAtomValue } from "@mdotm/shadcn/legacy/reactivity";
import { useMemo } from "react";
import { userClassifications$ } from "../user-classifications";

type InstrumentTagClassificationSelectProps = Pick<SelectProps<string | null>, "value" | "onChange">;

function InstrumentTagClassificationSelect(props: InstrumentTagClassificationSelectProps): React.JSX.Element {
	const userClassifications = useAtomValue(userClassifications$);

	const options = useMemo<Array<Option<string | null>>>(
		() => [
			{ label: "Ungrouped", value: null },
			...userClassifications.flatMap((x) =>
				x.fieldType === "TAG" ? [{ label: x.name!, value: x.classificationUuid! }] : [],
			),
		],
		[userClassifications],
	);

	return (
		<FormField label="Group by">
			{(formFieldProps) => <Select {...formFieldProps} {...props} size="x-small" options={options} />}
		</FormField>
	);
}

export default InstrumentTagClassificationSelect;
